import { useLingui } from '@lingui/react/macro'

import { OrganizationSettings } from '@/features/organization'
import { DialogHeader } from '@/layouts/Dialog'

const OrganizationSettingsDialog: React.FC = () => {
  const { t } = useLingui()

  return (
    <div className="flex flex-col p-8">
      <DialogHeader title={t`Settings`} description={t`Hotel Settings`} />
      <OrganizationSettings />
    </div>
  )
}

export default OrganizationSettingsDialog
